<template>
    <Paper>
        <div class="calendar-available-item-wrapper d-flex align-items-center clickable">
            <div class="calendar-available-item-content d-flex flex-column justify-content-center">
                <h5 class="title calendar-event-title">{{ data.title }}</h5>
                <slot name="details"> </slot>
                <div class="flex-grow" />
                <slot name="actions"> </slot>
            </div>
        </div>
    </Paper>
</template>

<script>
import Paper from '~/components/builders/Paper';

export default {
    name: 'BookAppointmentCard',
    components: {
        Paper,
    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style scoped>
.calendar-available-item-wrapper {
    padding: 1rem;
    height: 100%;
}

.calendar-available-item-content {
    height: 100%;
    margin-left: 1rem;
    margin-right: 1rem;
    width: 100%;
}

.calendar-available-item-span {
    font-size: 12px;
    padding-top: 5px;
    color: #141414;
}

.calendar-event-title {
    font-weight: bold !important;
    color: rgba(0, 0, 0, 0.7);
}

.first-available {
    color: var(--primary);
}
.divider {
    margin: 0;
    width: 100%;
    border-top: 1px solid #f3f3f3;
}

.details-container {
    display: flex;
    flex-direction: row;
}

.details-item {
    padding-right: 1em;
    padding-bottom: 1em;
}

.action-container {
    display: flex;
    flex-direction: row;
}
.action-item {
    padding-right: 1em;
}

/* TODO: won't work from inside the button... */
.outline-primary {
    border-color: var(--primary);
    color: var(--primary);
}
.outline-primary:hover:not(.disabled) {
    background-color: var(--primary);
    color: white;
}
.outline-primary:active {
    border-color: var(--primary);
    outline-width: 2px;
    outline-color: var(--primary);
}
</style>
